// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
}

const IconSearch = ({ className, fill, stroke }: PropsT) => (
  <svg className={classnames('Icon IconSearch', className)} viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>
    <title>Search</title>
    <g id='search'>
      <path d='M17.5057754,15.1190972 C18.1647415,15.7780634 18.1647415,16.8468092 17.5057754,17.5057754 C16.8468092,18.1647415 15.7780634,18.1647415 15.1190972,17.5057754 L12.7327003,15.1190972 C12.2914207,14.6778177 12.1471401,14.0528826 12.2970457,13.4903848 L10.9203323,12.0554529 C9.77227433,12.9591056 8.32468623,13.4999473 6.74997363,13.4999473 C3.02201945,13.4999473 0,10.4779278 0,6.74997363 C0,3.02201945 3.02201945,0 6.74997363,0 C10.4779278,0 13.4999473,3.02201945 13.4999473,6.74997363 C13.4999473,8.32468623 12.9591056,9.77227433 12.0554529,10.9203323 L13.4903848,12.2970457 C14.0528826,12.1471401 14.6778177,12.2914207 15.1190972,12.7327003 L17.5057754,15.1190972 Z M1.5,6.75 C1.5,9.64485 3.85515,12 6.75,12 C9.64485,12 12,9.64485 12,6.75 C12,3.85515 9.64485,1.5 6.75,1.5 C3.85515,1.5 1.5,3.85515 1.5,6.75 Z' id='Path-2' />
    </g>
  </svg>
)

export default IconSearch
